"use strict";
(function ($) {
    // Add scrollToTop class if you want to scroll to the top of the form when you click on that field
    $('.scrollToTop').on('click', function () {
        var top = $('html').offset().top;
        $('html,body').stop().animate({ scrollTop: top }, 500);
    });
    // Add scrollToThis class to a field you'd like to scroll to after clicking on that field
    $('.scrollToThis').on('click', function () {
        var target = $(this).offset().top;
        $('html,body').animate({ scrollTop: target }, 500);
    });
})(jQuery);
